import Api from './Api.service';

export default class PlanificadorService {

    static DescargarPlanificacion() {
        return Api.getBlob(`descargar/planificacion`);
    }
    static DescargarPlanificacionPost(body) {
        return Api.postBlob(`descargar/planificacionids`,body);
    }

    static ObtenerCarreraAnio(modalidad, anio) {
        return Api.get(`planificicacion/${modalidad}/${anio}`);
    }
    static ObtenerTodo(anio) {
        return Api.get(`diasnolaborales/${anio}`);
    }

    static ObtenerDiasDisponibles(comisionId) {
        return Api.get(`planificacion/dias/${comisionId}`);
    }

    static ObtenerNumerica(anio) {
        return Api.get(`numericaplanificacion/${anio}`);
    }

    static ObtenerDetalle(id) {
        return Api.get(`detalle/comision/docente/${id}`);
    }

    static PlanificaiconParcial(comisionId, disponibilidadId) {
        return Api.get(`planificacionparcial/${comisionId}/${disponibilidadId}`);
    }
    static AgregarTutoria(comisionId, fecha) {
        return Api.get(`tutoria/add/${comisionId}/${fecha}`);
    }
    static BorrarTutoria(comisionId, tutoriaId, fecha) {
        return Api.get(`tutoria/del/${comisionId}/${tutoriaId}/${fecha}`);
    }

    static novedadDia(day) {
        return Api.post('novedadDia', day);
    }
    static EditarComiPlani(id) {
        return Api.get(`comisionplani/editar/${id}`);
    }
    static EliminarComiPlani(id) {
        return Api.get(`comisionplani/eliminar/${id}`);
    }
    static ActualizarComiPlani(comision) {
        return Api.post('comisionplani/actualizar', comision);
    }

    static AgregarDisponibilidad(dispo) {
        return Api.post('disponibilidad/add', dispo);
    }
   
    static AgregarHorarioComision(body) {
        return Api.post('comision/horario', body);
    }


}